import "./App.css";
import Body3 from "./Components/Body3";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";

export default function App() {
  return (
    <>
      <div className="space-y-16">
        <Navbar />
        {/* <Body/> */}
        {/* <Body2/> */}
        <Body3 />
        <Footer />
      </div>
    </>
  );
}
